export const RP_DELIVERY_GAS_FUEL_GAS_MODEL_LIST = 'RP_DELIVERY_GAS_FUEL_GAS_MODEL_LIST'
export const RP_DELIVERY_GAS_FUEL_GAS_SEARCH = 'RP_DELIVERY_GAS_FUEL_GAS_SEARCH'
export const RP_DELIVERY_GAS_FUEL_PAGINATION = 'RP_DELIVERY_GAS_FUEL_PAGINATION'
export const RP_DELIVERY_GAS_FUEL_GAS_DROP_DOWN_SEARCH_YEAR = 'RP_DELIVERY_GAS_FUEL_GAS_DROP_DOWN_SEARCH_YEAR'